var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.6926L12.772 8.71383C13.1159 7.60157 13.1369 6.41455 12.8325 5.29084C12.5282 4.16713 11.911 3.15293 11.0529 2.36621C10.1947 1.57949 9.13084 1.05259 7.98497 0.846809C6.8391 0.641027 5.65835 0.764818 4.58008 1.20378L4.5809 1.6832L8.05813 5.16041L5.16112 8.05739L1.68388 4.58019H1.20364C0.764703 5.65857 0.641001 6.83943 0.84693 7.98536C1.05286 9.1313 1.57995 10.1952 2.36688 11.0533C3.15381 11.9114 4.16823 12.5284 5.2921 12.8325C6.41598 13.1367 7.60312 13.1154 8.71539 12.7713L12.6934 16.75M11.8238 11.8247L14.7209 14.7217",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.69f9b224f586e5109a54af04899eb3f9.svg";
export { ForwardRef as ReactComponent };